export default __webpack_public_path__ + "static/media/tony_Excellent.b0beec08.mp3";